import { Skeleton, Stack } from "@mui/material";
import type { FC } from "react";

export const CompletedGoalListItemSkeleton: FC = () => (
	<Stack
		direction="row"
		alignItems="center"
		gap={1.2}
		px={1.6}
		py={1.2}
		width="100%"
	>
		<Skeleton
			variant="circular"
			width={40}
			height={40}
			sx={{ flexShrink: 0 }}
			animation="wave"
		/>
		<Stack flex={1} minWidth={0} gap={0.4}>
			<Skeleton variant="text" width="55%" height={16} animation="wave" />
			<Skeleton
				variant="rounded"
				height={6}
				sx={{ borderRadius: 3, opacity: 0.5 }}
				animation="wave"
			/>
			<Skeleton variant="text" width="35%" height={14} animation="wave" />
		</Stack>
		<Skeleton
			variant="circular"
			width={16}
			height={16}
			sx={{ flexShrink: 0 }}
			animation="wave"
		/>
		<Skeleton
			variant="circular"
			width={16}
			height={16}
			sx={{ flexShrink: 0 }}
			animation="wave"
		/>
	</Stack>
);
